import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import IShift from '../../../app/_interfaces/IShift';
import { environment } from '../../../environments/environment';

@Injectable({
  providedIn: 'root',
})
export class ShiftsService {
  constructor(private http: HttpClient) {}

  get(id: number) {
    return this.http.get<IShift[]>(
      `${environment.api.protocol}://${environment.api.host}:${environment.api.port}/api/v1/customers/${id}/shifts`,
      {}
    );
  }

  create(
    customers_id: number,
    sites_id: number,
    users_id: number,
    shift: IShift
  ) {
    return this.http.post(
      `${environment.api.protocol}://${environment.api.host}:${environment.api.port}/api/v1/customers/${customers_id}/sites/${sites_id}/users/${users_id}/shifts`,
      { shift }
    );
  }

  delete(
    customers_id: number,
    sites_id: number,
    users_id: number,
    shifts_id: number
  ) {
    return this.http.delete(
      `${environment.api.protocol}://${environment.api.host}:${environment.api.port}/api/v1/customers/${customers_id}/sites/${sites_id}/users/${users_id}/shifts/${shifts_id}`
    );
  }
}
